module.exports = __webpack_public_path__ + "img/ArrowDownnn.066a0d1b.png";